import DOMPurify from 'dompurify'

interface LearnMoreSectionContentTextProps {
  title?: string
  content: string
}

export default function LearnMoreSectionContentText({
  title,
  content,
}: LearnMoreSectionContentTextProps) {
  return (
    <section className="px-4 py-3 text-sm leading-relaxed">
      {title && (
        <h2 className="mb-4 text-[#101010] text-base font-semibold">{title}</h2>
      )}
      <div
        className="space-y-3 text-[#616161] [&_a]:underline [&_a]:font-semibold"
        suppressHydrationWarning
        dangerouslySetInnerHTML={{
          __html:
            typeof DOMPurify?.sanitize === 'function'
              ? DOMPurify.sanitize(content)
              : content,
        }}
      />
    </section>
  )
}
